// Includes Stripe-hosted invoices returned by the existing invoice payment flow.
// https://docs.stripe.com/invoicing/hosted-invoice-page
const STRIPE_CHECKOUT_HOSTS = new Set([
  "checkout.stripe.com",
  "billing.stripe.com",
  "invoice.stripe.com",
]);

/** Shared by server responses and every browser checkout navigation path. */
export function safeStripeCheckoutUrl(value: unknown): string | null {
  if (typeof value !== "string") return null;
  try {
    const url = new URL(value);
    if (
      url.protocol !== "https:" ||
      !STRIPE_CHECKOUT_HOSTS.has(url.hostname) ||
      url.username ||
      url.password ||
      url.port
    )
      return null;
    return url.href;
  } catch {
    return null;
  }
}

export function requireStripeCheckoutUrl(value: unknown): string {
  const url = safeStripeCheckoutUrl(value);
  if (!url) throw new Error("A secure payment link is unavailable. Please try again.");
  return url;
}
